import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-rename',
  templateUrl: './rename.component.html',
  styleUrls: ['./rename.component.scss'],
  imports:[DependenciesModule]
})
export class RenameComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() confirmRename  = new EventEmitter();
  universalService: any;
  listService:any;
  router:any;
  fileName:any;
  renameError:string = "";
  enableButton:boolean = false;
  showRenameModal:boolean = false;
  @ViewChild("newName", {static: false}) renamedFile: ElementRef;

  constructor(public globalService:GlobalService,
    private changeDetectorRef: ChangeDetectorRef) { 
    this.setEnvObjects(this.globalService)
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showRenameModal) {
      this.listService.deSelectAll(event)
      this.enableButton = false;
    }else if (event.key === "Enter" && this.enableButton && this.showRenameModal){
      this.renameError = "";
      this.renameObject()
    }
  }

  ngOnInit(): void {
    let classRef = this;
    AppEvents.optionSelected.subscribe(event => {
      console.log("rename", event)
      if(event["rename"]){
        classRef.showRenameModal = event["rename"];
        classRef.initilizeFileProps();
        this.changeDetectorRef.detectChanges();
      } else if(event["closeAll"] || event["rename"]== false){
        classRef.showRenameModal = false;
        this.changeDetectorRef.detectChanges();
      }
    })

  }


  initilizeFileProps(){
    this.renameError = "";
    if(this.universalService.selectedFile["objectType"] == "FR"){
      this.fileName = this.universalService.selectedFile["objectName"]
    }else{  
      this.fileName = this.universalService.selectedFile["extension"]!=""?this.universalService.selectedFile["objectName"].split(this.universalService.selectedFile["extension"])[0]:this.universalService.selectedFile["objectName"]
    }
    setTimeout(()=>{
      $(document).off('focusin.modal');
      let temp = <HTMLInputElement>document.getElementById("rename_input_box");
      let len = temp.value.length;
      (<HTMLInputElement>document.getElementById("rename_input_box")).focus();
      temp.setSelectionRange(len, len);
    },0)
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.router = globalService.getRouterRef();
  }

  closePopUp(){
    this.close.emit();
    this.enableButton = false;
    this.renameError = "";
    AppEvents.optionSelected.next({rename: false})
  }

  newNameValidation(newName){
    var currentName = this.universalService.selectedFile["objectType"]=="FR"?this.universalService.selectedFile["objectName"]:this.universalService.selectedFile["objectName"].split(this.universalService.selectedFile["extension"])[0]
    var regex =  /[/\/\\/<>:"|?*]/;
    this.fileName = newName.value
    if(this.fileName == "" || this.fileName.trim().length == 0){
      this.enableButton = false;
      this.renameError = "Please enter a name."
    }else if(this.fileName.match(regex)){
      this.enableButton = false;
      this.renameError = "Please enter a name without / \\ < > : \" | ? *"
    } else if(this.fileName.charAt(this.fileName.length-1) == '.'){
      this.enableButton = false;
      this.renameError = "Folder name cannot end with ' . '"
    } else if(!(this.fileName.match(regex))){
        this.enableButton  = true;
        this.renameError = "";    
    }
    let renameEl = (document.getElementById(newName.id)) as any;
    if(renameEl.value.length >= 200){
      renameEl.value = renameEl.value.substr(0, 200);
    }
    console.log("rename textrv length",renameEl.value.length)
  }
  
  renameObject(){
    var operationName = ""
    this.universalService.selectedFileOldName = this.universalService.selectedFile["objectName"]
    this.universalService.selectedFile["actualObjectName"] = this.universalService.selectedFile["objectName"]
    this.universalService.selectedFile["objectName"] = this.fileName + this.universalService.selectedFile["extension"]

    if(this.universalService.selectedTab == 'Album Details'){
      operationName = "FRN"
    }else{
      operationName = "RENAME"
    }
    var object = {
      "files":this.universalService.selectedFile,
      "operation":operationName,
      "correlationId": USER_DETAILS["USER_DETAILS"]["userId"]
    }
    this.confirmRename.emit(object);
    this.enableButton = false;
  }

}
